module.exports = function() {
  return new Worker(__webpack_public_path__ + "0a15ee9b6915971e979e.worker.js");
};